
import {Component, Ref, Vue, Watch} from "vue-property-decorator";
import IlamBilgileriList from "@/components/takip/list/IlamBilgileriList.vue";
import TakipYoluList from "@/components/takip/list/TakipYoluList.vue";
import KiraBilgileriList from "@/components/takip/list/KiraBilgileriList.vue";
import ItemArrayManager from "@/components/common-inputs/ItemArrayManager.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import {TakipEntity} from "@/entity/TakipEntity";
import TakipForm from "@/components/forms/TakipForm.vue";
import AlacakList from "@/components/lists/AlacakList.vue";
import BorcluCardList from "@/components/lists/BorcluCardList.vue";
import AlacakliCardList from "@/components/lists/AlacakliCardList.vue";
import TakipEkAlanList from "@/components/lists/TakipEkAlanList.vue";
import TakipEkAlan from "@/components/forms/TakipEkAlanForm.vue";
import KapakHesabiInfo from "@/components/infos/KapakHesabiInfo.vue";
import DokumanList from "@/components/lists/DokumanList.vue";
import DilekceForm from "@/components/forms/DilekceForm.vue";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {GezintiAraclari, takipKomsusunaGit} from "@/helpers/TakipListeGezintiHelper";
import IsList from "@/components/lists/IsList.vue";
import KapakHesabi from "@/components/infos/KapakHesabi.vue";
import {AlacakEntity} from "@/entity/AlacakBelgeler/AlacakEntity";

type FaizDataType = {
  hesaplanabilir: boolean;
  data: TakipEntity | { message: string };
};

@Component({
  components: {
    KapakHesabi,
    IsList,
    DilekceForm,
    DokumanList,
    KapakHesabiInfo,
    AlacakList,
    AlacakliCardList,
    BorcluCardList,
    TakipForm,
    FormDialog,
    ItemArrayManager,
    KiraBilgileriList,
    TakipYoluList,
    IlamBilgileriList,
    TakipEkAlanList,
    TakipEkAlan
  }
})
export default class TakipEkleView extends Vue {
  @Ref('isList') readonly isListesi!: IsList;
  ProgramPaths = ProgramPaths;

  // Son faiz isteği zamanı
  lastFaizRequestTime: number = 0;
  // Minimum istek aralığı (milisaniye)
  minRequestInterval: number = 1000; // 1 saniye
  // Faiz isteği için zamanlayıcı
  faizRequestTimer: any = null;

  // Speed Dial için değişkenler
  fab = false;
  show = false;
  show1 = false;
  show2 = false;
  hover = false;
  takipFiles: any = [];
  maxTryTime: number = 2;
  tryCounter: number = 0;
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {

      if (!to.params.id || to.params.id === 'new' || to.params.id === 'yeni') {
        vm.$store.commit('takipEkle/resetState');
      }
    });
  }

  @Watch('show1')
  openFiles() {
    if (this.show1) {
      this.$http.get('/api/v1/takip/' + this.$route.params.id + '/files').then((response) => {
        this.takipFiles = response.data.files;
      });
    }
  }

  @Watch('$route.params.id', { immediate: true, deep: true })
  async onRouteIdChange(newId: string, oldId: string) {
    if (!newId) {
      this.$store.commit('takipEkle/resetState');
      return;
    }
    if (newId === 'new' || newId === 'yeni') {
      this.$store.commit('takipEkle/resetState');
      return;
    }
    await this.updateTakipData(newId, false);
  }

  mounted() {
    let activeProcess = { id: this.$route.params.id, key: 'takip-ac', isRoot: true };
    this.$store.commit('setActiveProcess', activeProcess);
    // Adres güncelleme kontrolü
    const sonAdresGuncelleme = localStorage.getItem('son_adres_guncelleme');
    const guncellenenBorcluId = localStorage.getItem('guncellenen_borclu_id');
    if (sonAdresGuncelleme && guncellenenBorcluId && this.$route.params.id) {
      const guncellemeTarihi = new Date(sonAdresGuncelleme);
      const suAn = new Date();
      const zamanFarki = suAn.getTime() - guncellemeTarihi.getTime();
      const besDAkika = 5 * 60 * 1000;
      if (zamanFarki < besDAkika) {
        this.updateComponentData('borclular');
        localStorage.removeItem('son_adres_guncelleme');
        localStorage.removeItem('guncellenen_borclu_id');
      }
    }
  }

  // --- Vuex Getters ---
  get item(): TakipEntity {
    return this.$store.getters['takipEkle/item'];
  }
  get isIkili(): boolean {
    return this.$store.getters['takipEkle/isIkili'];
  }
  get takipBorclular(): { isGetted: boolean, data: any[] } {
    return this.$store.getters['takipEkle/takipBorclular'];
  }
  get takipAlacaklilar(): { isGetted: boolean, data: any[] } {
    return this.$store.getters['takipEkle/takipAlacaklilar'];
  }
  get takipAlacaklar(): { isGetted: boolean, data: any[] } {
    return this.$store.getters['takipEkle/takipAlacaklar'];
  }
  get takipIsler(): { isGetted: boolean, data: any[] } {
    return this.$store.getters['takipEkle/takipIsler'];
  }
  get faizData(): any {
    return this.$store.getters['takipEkle/faizData'];
  }
  get faizLoading(): boolean {
    return this.$store.getters['takipEkle/faizLoading'];
  }
  get alacaklilarLoading(): boolean {
    return this.$store.getters['takipEkle/alacaklilarLoading'];
  }
  get borclularLoading(): boolean {
    return this.$store.getters['takipEkle/borclularLoading'];
  }
  get alacaklarLoading(): boolean {
    return this.$store.getters['takipEkle/alacaklarLoading'];
  }
  get islerLoading(): boolean {
    return this.$store.getters['takipEkle/islerLoading'];
  }
  get hasAlacakliData(): boolean {
    return this.$store.getters['takipEkle/hasAlacakliData'];
  }
  get hasBorcluData(): boolean {
    return this.$store.getters['takipEkle/hasBorcluData'];
  }
  get hasAlacakData(): boolean {
    return this.$store.getters['takipEkle/hasAlacakData'];
  }
  get hasIsListesiData(): boolean {
    return this.$store.getters['takipEkle/hasIsListesiData'];
  }
  get hasTakipId(): boolean {
    return this.$store.getters['takipEkle/hasTakipId'];
  }
  get selectedAlacakli(): any {
    return this.$store.getters['takipEkle/selectedAlacakli'];
  }
  get selectedBorclu(): any {
    return this.$store.getters['takipEkle/selectedBorclu'];
  }
  get selectedAlacak(): any {
    return this.$store.getters['takipEkle/selectedAlacak'];
  }
  get selectedIs(): any {
    return this.$store.getters['takipEkle/selectedIs'];
  }
  // --- Vuex Actions/Mutations ---
  async updateTakipData(id: any, forceReload = false, takip?: TakipEntity) {
    try {
      this.tryCounter++;
      if (!id) {
        this.$store.commit('takipEkle/resetState');
        return;
      }
      if (takip) {
        this.$store.commit('takipEkle/setItem', takip);
        return;
      }
      this.$store.commit('takipEkle/setFaizLoading', true);
      const success = await this.$store.dispatch('takipEkle/loadTakipBilgileri', id);
      if (!success) {
        this.$toast.warning('Takip verileri yüklenirken hata oluştu, tekrar deneniyor...');
        setTimeout(() => {
          if(this.maxTryTime > this.tryCounter){
            this.updateTakipData(id, true);
          }else{
            this.$toast.error('Takip verileri yüklenirken hata oluştu Lütfen sistem yöneticisi ile iletişime geçiniz.');
          }
        }, 1000);
      } else if (this.hasTakipId && this.$helper.isAuthorized('takip-kapak-hesabi-goruntule')) {
        this.getFaizData();
      }
    } catch (error) {
      this.$toast.error("Takip verileri yüklenirken bir hata oluştu");
      this.$store.commit('takipEkle/setFaizLoading', false);
    }
  }

  async handleComponentDataLoaded(componentType: string) {
    await this.updateComponentData(componentType);
    // isListesi için faiz verilerini tekrar yüklemeye gerek yok
    // bu gereksiz API çağrılarını önleyecek
    if (["alacaklilar", "borclular", "alacaklar"].includes(componentType)) {
      await this.getFaizData();
    }
  }

  async updateComponentData(componentType: string) {
    if (!this.$route.params.id) return;
    const takipId = this.$route.params.id.toString();
    try {
      await this.$store.dispatch('takipEkle/updateSingleComponent', { id: takipId, componentType });
      this.updateComponentDisplay(componentType);
    } catch (error) {
      this.$toast.error(`${this.getComponentName(componentType)} verileri yüklenirken bir hata oluştu`);
    }
  }

  updateComponentDisplay(componentType: string): void {
    this.$nextTick(() => {
      if (componentType === 'isListesi' && this.isListesi && typeof this.isListesi.search === 'function') {
        this.isListesi.search();
      }
    });
  }

  async handleComponentDataAdded(componentType: string, data?: any) {
    try {
      const takipId = this.getTakipId();
      if (!takipId) {
        this.$toast.error('Takip ID bulunamadı. Lütfen önce takip bilgilerini kaydedin.');
        return;
      }
      if (data) {
        await this.updateComponentData(componentType);
        // isListesi için faiz verilerini tekrar yüklemeye gerek yok
        // bu gereksiz API çağrılarını önleyecek
        if (["alacaklilar", "borclular", "alacaklar"].includes(componentType)) {
          await this.getFaizData();
        }
        this.$toast.success(`${this.getComponentName(componentType)} başarıyla eklendi`);
      }
    } catch (error) {
      this.$toast.error(`${this.getComponentName(componentType)} eklenirken bir hata oluştu`);
    }
  }

  getTakipId(): string | null {
    if (this.$route.params.id) {
      return this.$route.params.id.toString();
    }
    if (this.item && this.item.id) {
      return this.item.id.toString();
    }
    if (this.item && this.item.takip_bilgileri && this.item.takip_bilgileri.id) {
      return this.item.takip_bilgileri.id.toString();
    }
    return null;
  }

  handleComponentSelected(componentType: string, event: any) {
    if (!event) return;
    switch (componentType) {
      case 'alacaklilar':
        if (this.selectedAlacakli && this.selectedAlacakli.id === event.id) return;
        this.$store.commit('takipEkle/setSelectedAlacakli', event);
        break;
      case 'borclular':
        if (this.selectedBorclu && this.selectedBorclu.id === event.id) return;
        this.$store.commit('takipEkle/setSelectedBorclu', event);
        break;
      case 'alacaklar':
        if (this.selectedAlacak && this.selectedAlacak.id === event.id) return;
        this.$store.commit('takipEkle/setSelectedAlacak', event);
        break;
      case 'isListesi':
        if (this.selectedIs && this.selectedIs.id === event.id) return;
        this.$store.commit('takipEkle/setSelectedIs', event);
        break;
      case 'kapakHesabi':
        if (this.faizLoading) return;
        this.getFaizData();
        break;
    }
  }

  async getFaizData() {
    // Takip ID yoksa işlem yapmayalım
    if (!this.hasTakipId) {
      return;
    }

    const now = Date.now();

    // Son istekten bu yana yeterli zaman geçmediyse bekletelim
    if (now - this.lastFaizRequestTime < this.minRequestInterval) {
      // Önceki zamanlayıcıyı temizle
      if (this.faizRequestTimer) {
        clearTimeout(this.faizRequestTimer);
      }

      // Yeni bir zamanlayıcı oluştur
      this.faizRequestTimer = setTimeout(() => {
        this.getFaizData();
      }, this.minRequestInterval);

      return;
    }

    // Zaten yükleme yapılıyorsa işlem yapmayalım
    if (this.faizLoading) {
      return;
    }

    try {
      // İstek zamanını kaydet
      this.lastFaizRequestTime = now;

      // Faiz verilerinin yüklenmekte olduğunu belirt
      this.$store.commit('takipEkle/setFaizLoading', true);

      // Faiz verilerini yükle
      await this.$store.dispatch('takipEkle/getFaizData', {
        id: this.$route.params.id.toString()
      });
    } catch (error) {
      console.error("Faiz verileri yüklenirken hata:", error);
      this.$toast.error('Kapak hesabı verileri güncellenirken bir hata oluştu');
      this.$store.commit('takipEkle/setFaizLoading', false);
    }
  }

  // DEV-2857: karta takip listesinden gelindiyse o listenin (filtre + arama +
  // sıralama) sırası izlenir; aksi halde veritabanı sırası (TakipListeGezintiHelper).
  birSonrakiTakip() {
    return takipKomsusunaGit(Number(this.$route.params.id), 'ileri', this.gezintiAraclari());
  }

  birOncekiTakip() {
    return takipKomsusunaGit(Number(this.$route.params.id), 'geri', this.gezintiAraclari());
  }

  private gezintiAraclari(): GezintiAraclari {
    return {http: this.$http, router: this.$router, toast: this.$toast};
  }

  getComponentName(componentType: string): string {
    switch (componentType) {
      case 'alacaklilar': return 'Alacaklı';
      case 'borclular': return 'Borçlu';
      case 'alacaklar': return 'Alacak';
      case 'isListesi': return 'İş';
      case 'kapakHesabi': return 'Kapak Hesabı';
      default: return 'Veri';
    }
  }

  loadKiraKontrati(data: any[]) {
    this.$store.dispatch('takipEkle/loadKiraKontrati', data);
  }

  handleTakipSuccess(newTakip: any) {
    /*this.$store.commit('takipEkle/resetState');*/
    if (newTakip && newTakip.id) {
      this.$router.push(`/icrapro/takip-ekle/${newTakip.id}`);
    } else if (this.item && this.item.id) {
      this.$router.push(`/icrapro/takip-ekle/${this.item.id}`);
    }
    this.getFaizData()
  }

  handleTakipYoluChanged(takipYoluData: any) {
    // Takip yolu değiştiğinde sadece gerekli verileri güncelleyelim
    if (!takipYoluData) return;

    const takipId = this.getTakipId();
    if (!takipId) return;

    // Kullanıcıya bilgi ver
    this.$toast.info("Takip yolu değişikliği işleniyor...");

    try {
      // Mevcut takip nesnesini klonlayalım
      const updatedTakip = JSON.parse(JSON.stringify(this.item.takip_bilgileri));

      // Takip talebi içinde takip yolu bilgisini güncelleyelim
      if (updatedTakip && updatedTakip.talepler && updatedTakip.talepler.length > 0) {
        const currentTalep = updatedTakip.talepler[0];
        currentTalep.takip_yolu_id = takipYoluData.yoluId;

        // Eğer formData içinde manuel_takip_yolu varsa onu da güncelleyelim
        if (takipYoluData.formData && takipYoluData.formData.manuel_takip_yolu !== undefined) {
          currentTalep.manuel_takip_yolu = takipYoluData.formData.manuel_takip_yolu;
        }

        // Vuex store'da takip bilgilerini güncelleyelim
        this.$store.commit('takipEkle/setItem', { takip_bilgileri: updatedTakip });

        // Önceki zamanlayıcıyı temizle
        if (this.faizRequestTimer) {
          clearTimeout(this.faizRequestTimer);
          this.faizRequestTimer = null;
        }

        // Faiz hesaplamalarını güncellemek için API çağrısı yapalım
        this.$store.commit('takipEkle/setFaizLoading', true);

        // Takip yolu değişikliğini API'ye gönderelim
        const talepId = currentTalep.id;
        if (talepId) {
          // Tüm gerekli alanları içeren tam talep nesnesini gönder
          const talepData = {
            id: talepId,
            takip_yolu_id: currentTalep.takip_yolu_id,
            takip_tipi_id: currentTalep.takip_tipi_id,
            takip_alt_tipi_id: currentTalep.takip_alt_tipi_id,
            takip_id: takipId,
            manuel_takip_yolu: currentTalep.manuel_takip_yolu,
            takip_mahiyeti_id: currentTalep.takip_mahiyeti_id
          };

          // Vuex store üzerinden takip talebini güncelle
          this.$store.dispatch('takipEkle/updateTakipTalebi', talepData)
              .then(() => {
                this.$toast.success("Takip yolu başarıyla güncellendi");
              })
              .catch(error => {
                console.error("Takip yolu güncellenirken hata:", error);
                this.$toast.error("Takip yolu güncellenirken bir hata oluştu: " + (error.response?.data?.message || "Bilinmeyen hata"));
                this.$store.commit('takipEkle/setFaizLoading', false);
              });
        } else {
          // Talep ID yoksa doğrudan faiz verilerini yenile
          this.getFaizData();
        }
      }
    } catch (error) {
      console.error("Takip yolu güncellenirken hata:", error);
      this.$toast.error("Takip yolu güncellenirken bir hata oluştu");
      this.$store.commit('takipEkle/setFaizLoading', false);
    }
  }
}
